export default __webpack_public_path__ + "static/media/logoFooterGold.17bb1398.svg";